import { render } from "./new_banks_form.vue?vue&type=template&id=3edba8ea&scoped=true"
import script from "./new_banks_form.vue?vue&type=script&lang=js"
export * from "./new_banks_form.vue?vue&type=script&lang=js"

import "./new_banks_form.vue?vue&type=style&index=0&id=3edba8ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edba8ea"]])

export default __exports__